
















import Vue from 'vue'

export default Vue.extend({
  name: 'AddButton',
  props: {
    tooltip: {
      type: String,
      default: '',
    },
  },
})
